import React, { useLayoutEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import TimesheetSectionThreeRow from './TimesheetSectionThreeRow';
import { FormatInvoiceDecimalNumber, getValueFromResource } from '../../common/timeLiveFunction';
import { t } from 'i18next';

const TimesheetTableSectionThree = () => {
    const { isLocked, timeEntriesList, totalHours, isHoliday, IsMyTimeOff } = useAppSelector((state) => state.timesheet);
    const dispatch =useAppDispatch();
    const { showTimeOffInTimesheet ,decimalPlaces,cultureInfoName} = useAppSelector((state) => state.globalState);

    return (
        <div id="section-three" className={"totalPanel tableContainerCol"}>
            <table id="tblTotal" className={"table data-table time-entry-table"}>
                <thead>
                    <tr>
                        <th style={{ verticalAlign: 'middle', height: isHoliday ? '65px' : '58px' }}><span>Total</span></th>
                        {!isLocked && <th style={{ borderTopRightRadius: '5px', borderBottomRightRadius: '5px', borderRightStyle: 'hidden' }}></th>}
                    </tr>
                </thead>
                <tbody>
                    {timeEntriesList.map((x, i) =>
                        x.isTimeOff != true &&
                        <TimesheetSectionThreeRow
                            key={i}
                            rowId={x.rowId}
                        />
                    )}
                {IsMyTimeOff && showTimeOffInTimesheet && (
  <tr style={{ height: '15px' }}>
    <td style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden', borderBottom: '1px solid #eff2f5', padding: 0 }}></td>
    {!isLocked && <td style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden', borderBottom: '1px solid #eff2f5', padding: 0 }}></td>}
  </tr>
)}
                    {IsMyTimeOff && showTimeOffInTimesheet && <tr className={"timesheet-row"}>
                        <td style={{ height: 74, borderRightWidth: 0, borderRight: '0px solid #fafbfc !important' }}>
                            <div style={{ height: 58, marginTop: -1, backgroundColor: '#f0f1f4', width: isLocked ? 138 : 158.5, borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}>
                                <div style={{ paddingTop: 15 }}>
                                    <span style={{ marginLeft: -38, fontSize: 13, textTransform: 'uppercase' }}>
                                        {/* {`Total`} */}
                                        {getValueFromResource('Total',dispatch, t)}
                                        </span>
                                </div>
                            </div>
                        </td>
                    </tr>}
                    {IsMyTimeOff && showTimeOffInTimesheet && timeEntriesList.map((x: any, i) =>
                        x.isTimeOff &&
                        <TimesheetSectionThreeRow
                            key={i}
                            rowId={x.rowId}
                            isReadOnly={true}
                        />
                    )}
                    {IsMyTimeOff && showTimeOffInTimesheet && !timeEntriesList.some((x: any) => x.isTimeOff) && (
  <tr style={{ height: '45px' }}>
    <td style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden', padding: 0, backgroundColor: '#ffffff' }}>
      <div style={{ height: '45px' }}></div>
    </td>
    {!isLocked && (
      <td style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden', padding: 0, backgroundColor: '#ffffff' }}>
        <div style={{ height: '45px' }}></div>
      </td>
    )}
  </tr>
)}
                </tbody>
                <tfoot>
                    <tr className={"timehseet-row total-row dark text-center"}>
                        <td style={{ padding: 0 }}>
                            <div style={{ height: 55, marginTop: 8, verticalAlign: 'middle', backgroundColor: '#f0f1f4' }}>
                                <span className={"footer-duration-value fw-bold"}>{FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(totalHours), 2)}</span>
                            </div>
                        </td>
                        {!isLocked && <td style={{ padding: 0 }}><div style={{ height: 55, marginTop: 8, verticalAlign: 'middle', backgroundColor: '#f0f1f4', borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}></div></td>}
                    </tr>
                </tfoot>
            </table>
            <table id="tblTotal-header-fixed" className={"header-fixed"} style={{ display: "none" }}></table>
            <table id="tblTotal-footer-fixed" className={"footer-fixed"} style={{ display: "none" }}></table>
        </div>
    )
}

export default TimesheetTableSectionThree